import { IonModal } from "@ionic/angular";

abstract class Modal<StateT = unknown> {
  canDismiss = true;
  isOpen = false;
  state: StateT = this.getInitialState();

  abstract getInitialState(): StateT;
  abstract getModal(): IonModal;

  // Ensure the modal is open
  open() {
    if (this.isOpen) {
      return;
    }

    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
    if (this.getModal() === undefined) {
      console.error("Tried to open nonexistent modal!");
      return;
    }

    void this.getModal()
      .onDidDismiss()
      .then(() => {
        this.isOpen = false;
        this.getModal().isOpen = false;
      });
    this.isOpen = true;
    this.getModal().isOpen = true;
  }

  // Ensure the modal is closed
  async close() {
    if (!this.isOpen) {
      return;
    }

    await this.getModal().dismiss();
    this.isOpen = false;
  }

  // Context-dependent back button function
  async back() {}
}

export { Modal };
